import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CustomizedTables(props) {
  return (
    <TableContainer
      sx={{ maxHeight: 250 }}
      component={Paper}
      style={{ boxShadow: "none" }}
    >
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableBody>
          {props.rows.map((row, i) => (
            <StyledTableRow key={i} style={{}}>
              <StyledTableCell
                style={{
                  width: "50%",
                  paddingLeft: "30px",
                  fontWeight: "700",
                }}
                className="dark:bg-lightBlack2 dark:text-white text-[#303E55]"
              >
                {row.name}
              </StyledTableCell>
              <StyledTableCell
                style={{ width: "50%", paddingRight: "30px" }}
                className="dark:bg-lightBlack2 dark:text-white text-[#303E55]"
              >
                {row.value}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
